import { useState } from "react";
import { InView } from "react-intersection-observer";
import posthog from "posthog-js";

import useAppSelector from "@/hooks/useAppSelector";
import { recombeeToCart } from "@/utils/product";

import type { RecombeeValuesItemUser } from "@/types/recombee";
import { useQuery } from "@tanstack/react-query";

import { getMostPurchasedHub } from "@/services/recombee";
import useSessionContext from "@/hooks/useSesionContext";
import CategoriesSectionProductGallery from "@/components/Organisms/CategoriesSectionProductGallery";

const HubPopoular = () => {
  const { isAthenticated } = useSessionContext();
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userID = posthog.get_distinct_id();
  const [inView, setInView] = useState(false);

  const { data, error, isFetching, isFetched } = useQuery({
    queryKey: ["hubPopular", userID, storeId, isAthenticated()],
    queryFn: async () => {
      const result = await getMostPurchasedHub(userID, String(storeId));

      if (!result.data?.success) {
        throw new Error("No data");
      }

      const { payload } = result.data;
      const { recommendations, hub } = payload;

      const items: Cart[] = recommendations.recomms.map((recom) =>
        recombeeToCart(Number(recom.id), storeId!, recom.values as unknown as RecombeeValuesItemUser)
      );

      return {
        items,
        hub,
        id: recommendations.recommId,
      };
    },
    enabled: !!userID && !!storeId && inView,
  });

  if (error) {
    return null;
  }

  if (isFetching || !storeId || !userID || (!inView && !isFetched)) {
    return (
      <InView
        onChange={(isView) => {
          if (!inView) setInView(isView);
        }}
        rootMargin="1500px 0px"
        triggerOnce
      >
        <CategoriesSectionProductGallery items={[]} recommId={""} isLoading />
      </InView>
    );
  }

  if (data?.items && data.items.length <= 0) {
    return null;
  }

  return (
    <CategoriesSectionProductGallery
      items={data?.items ?? []}
      title={`${data?.hub?.name}, el Hub favorito de todos`}
      recommId={data?.id}
      showViewMore
      to={`/h/${data?.hub?.slug}`}
    />
  );
};

export default HubPopoular;
